import { URLRequest } from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("CoreJS.BrowserUtil");

export class BrowserUtil {

    public static WINDOW_BLANK: string = "_blank";
    public static WINDOW_SELF: string = "_self";
    public static WINDOW_PARENT: string = "_parent";
    public static WINDOW_TOP: string = "_top";

    public static executeNavigateToURL(request: string | URLRequest, _target: string = BrowserUtil.WINDOW_BLANK): void {
        logger.debug("executeNavigateToURL ", request);
        if (typeof request === "string") {
            window.open(request, _target);
        } else {
            window.open(request.getURLWithParams(), _target);
        }
    }

    public static openWindow(urlRequest: URLRequest, target: string = BrowserUtil.WINDOW_BLANK, features: string = ""): void {
        if (features) {
            logger.warn("openWindow: what should we do with the 'features'", features);
        }
        BrowserUtil.executeNavigateToURL(urlRequest, target);

        // TODO: @HTML5 check behaviour  in case of feature and on Firefox it was calling   //ExternalInterface.call(WINDOW_OPEN_FUNCTION, url + params, target, features);

    }
}
